// src/components/Step3.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import axios from 'axios';
import ProgressMessage from './ProgressMessage';
import '../css/Step4.css';

const CategoryCSVExport = () => {
  const [statusMessage, setStatusMessage] = useState('대기중...');
  const [isExtracting, setIsExtracting] = useState(false);
  const [isFinished, setIsFinished] = useState(false);
  const [animatedText, setAnimatedText] = useState(''); // State for animated text

  const fullText = 'DB DATA => CSV FILE'; // Full text to animate

  // Effect to animate the text
  useEffect(() => {
    if (isExtracting) {
      let currentIndex = 0;

      // Timer to animate text
      const timer = setInterval(() => {
        setAnimatedText(fullText.slice(0, currentIndex + 1));
        currentIndex++;

        if (currentIndex === fullText.length) {
          currentIndex = 0; // Restart animation
        }
      }, 150); // Adjust speed here

      return () => clearInterval(timer); // Clean up on unmount or stop
    } else {
      setAnimatedText(fullText); // Reset text when not extracting
    }
  }, [isExtracting]);

  useEffect(()=> {
    const script = document.createElement('script');
    script.src = "https://cdnjs.cloudflare.com/ajax/libs/encoding-japanese/2.0.0/encoding.min.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  },[])
  const handleBack = () => {
    // Back button logic here
  };

  const downloadCSV = (data, fileName) => {
    // Blob 생성
    const blob = new Blob([data], { type: 'text/csv;charset=shift_jis;' });
    
    // 다운로드 링크 생성 및 클릭
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    
    // URL 해제 및 링크 제거
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };
  
  // 파일 분할 및 다운로드 함수
// 파일 분할 및 다운로드 함수
const splitAndDownloadCSV = async (data, baseFileName, maxFileSizeBytes) => {
  let offset = 0;
  let partCounter = 1;
  let header = null;
  const newlineBytes = [10, 13]; // \n(10), \r(13) 둘 다 허용
  let isFirstChunk = true;
  let chunkSize = 0;
  let currentChunk = [];
  
  console.log(`START SPLIT : ${baseFileName}, Total Data Length: ${data.length}`);
  
  while (offset < data.length) {
    // 다음 줄의 끝을 찾음
    let lineEnd = offset;
    while (lineEnd < data.length && !newlineBytes.includes(data[lineEnd])) {
      lineEnd++;
    }
    // 줄 바꿈 문자 포함
    if (lineEnd < data.length) {
      lineEnd++; // 줄 바꿈 문자 포함
    }
    
    // 한 줄을 추출
    const line = data.slice(offset, lineEnd);
    
    if (isFirstChunk && !header) {
      header = line;
    }
    
    // 현재 청크에 이 줄을 추가하면 최대 크기를 초과하는지 확인
    if (chunkSize + line.length > maxFileSizeBytes && currentChunk.length > 0) {
      // 청크 데이터를 준비
      let chunkData;
      if (isFirstChunk) {
        // 첫 번째 청크는 이미 헤더를 포함
        chunkData = new Uint8Array(currentChunk.reduce((acc, arr) => acc + arr.length, 0));
        let pos = 0;
        for (let i = 0; i < currentChunk.length; i++) {
          chunkData.set(currentChunk[i], pos);
          pos += currentChunk[i].length;
        }
        isFirstChunk = false;
      } else {
        // 헤더를 현재 청크 앞에 추가
        let totalLength = header.length + currentChunk.reduce((acc, arr) => acc + arr.length, 0);
        chunkData = new Uint8Array(totalLength);
        chunkData.set(header, 0);
        let pos = header.length;
        for (let i = 0; i < currentChunk.length; i++) {
          chunkData.set(currentChunk[i], pos);
          pos += currentChunk[i].length;
        }
      }
      
      // 청크 다운로드
      const fileName = `${baseFileName}_part_${partCounter}.csv`;
      console.log(`Downloading Part ${partCounter}: ${fileName}`);
      downloadCSV(chunkData, fileName);
      
      // 다음 청크를 위해 초기화
      currentChunk = [];
      chunkSize = 0;
      partCounter++;
      
      // UI 업데이트를 위해 잠시 대기
      await new Promise(resolve => setTimeout(resolve, 50));
    }
    
    // 현재 청크에 줄 추가
    currentChunk.push(line);
    chunkSize += line.length;
    
    // 다음 줄로 이동
    offset = lineEnd;
  }
  
  // 모든 줄을 처리한 후 남은 데이터가 있으면 다운로드
  if (currentChunk.length > 0) {
    let chunkData;
    if (isFirstChunk) {
      chunkData = new Uint8Array(currentChunk.reduce((acc, arr) => acc + arr.length, 0));
      let pos = 0;
      for (let i = 0; i < currentChunk.length; i++) {
        chunkData.set(currentChunk[i], pos);
        pos += currentChunk[i].length;
      }
    } else {
      let totalLength = header.length + currentChunk.reduce((acc, arr) => acc + arr.length, 0);
      chunkData = new Uint8Array(totalLength);
      chunkData.set(header, 0);
      let pos = header.length;
      for (let i = 0; i < currentChunk.length; i++) {
        chunkData.set(currentChunk[i], pos);
        pos += currentChunk[i].length;
      }
    }
    
    const fileName = `${baseFileName}_part_${partCounter}.csv`;
    console.log(`Downloading Part ${partCounter}: ${fileName}`);
    downloadCSV(chunkData, fileName);
  }
  
  console.log(`Completed Split and Download for ${baseFileName}`);
};

  
  

  const convertCategoriesTable = () => {
    setIsExtracting(true);
    setStatusMessage('Categories DB를 CSV로 변환중...');

    axios.post('http://localhost:5000/export-db-to-csv/extract-db-categories')
      .then(response => {
        setStatusMessage('Categories DB를 CSV로 변환 완료.');
  
        if (response.data.file) {
          // Convert the base64 encoded file back to binary data
          const binaryData = new Uint8Array(response.data.file.data);
          downloadCSV(binaryData, 'output_categories.csv');
				}
        setTimeout(() => {
          convertApiDisplayTable();
        }, 500)
      })
      .catch(error => {
        console.error('Error during conversion:', error);
        setStatusMessage('Category DB를 CSV로 변환 중 오류가 발생했습니다.');
        setIsExtracting(false);
      });
  }

  const convertApiDisplayTable = () => {
    setIsExtracting(true);
    setStatusMessage('가상카테고리 DB를 CSV로 변환중...');

    axios.post('http://localhost:5000/export-db-to-csv/extract-db-api-display')
      .then(response => {
        setStatusMessage('Categories DB를 CSV로 변환 완료.');
        

        if (response.data.file) {
          // Convert the base64 encoded file back to binary data
          const binaryData = new Uint8Array(response.data.file.data);
          
          // 파일 크기 체크 (150kb =0.15mb = 0.1 * 1024 * 1024 바이트) 
          const maxFileSizeBytes = 0.15 * 1024 * 1024;
          
          if (binaryData.length > maxFileSizeBytes) {
            // 파일 크기가 0.1mb 이상일 때 분할 다운로드
            splitAndDownloadCSV(binaryData, 'output_display_category.csv', maxFileSizeBytes);
          } else {
            // 0.1mb 이하일 경우 그대로 다운로드
            downloadCSV(binaryData, 'output_display_category.csv');
          }
        }
        setTimeout(() => {
          setIsFinished(true);
					setIsExtracting(false);
        }, 500)
      })
      .catch(error => {
        console.error('Error during conversion:', error);
        setStatusMessage('API Display DB를 CSV로 변환 중 오류가 발생했습니다.');
        setIsExtracting(false);
      });
  }

  return (
    <motion.div
      className="step-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <h2>Extract Category DB to CSV</h2>
      {/* Animated Text */}
      <p className={`animated-text ${isExtracting ? 'extracting' : ''}`}>
        {animatedText}
      </p>
      <div className="conversion-container">
        <button
          onClick={handleBack}
          className='convert-button'
          disabled={isExtracting}
        >
          Back
        </button>
        <button
          onClick={convertCategoriesTable}
          className="convert-button"
          disabled={isExtracting}
        >
          Extract
        </button>
        <ProgressMessage message={statusMessage} />
        {isFinished && <Link to="/step4" className="next-button">Next</Link>}
      </div>
    </motion.div>
  );
};

export default CategoryCSVExport;
